import React, {useEffect, useState} from 'react';
import Main from "../../modules/main/main";
import usePermissions from "../../services/auth/usePermissions";
import useUser from "../../services/auth/useUser";
import {useNavigate} from "react-router-dom";
import {apiUsers} from "../../services/api/users";
import {capitalizeFirst, formatLocalDate} from "../../services/common";
import TimelineTab from '../user/tabs/timeline-tab';
import SettingsTab from '../user/tabs/settings-tab';
import Button from "@mui/material/Button";


function Profile(props) {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const currentUser = useUser();
    const [userCan] = usePermissions();
    const [rowData, setRowData] = useState({});
    const [allRoles, setAllRoles] = useState([]);
    const [title, setTitle] = useState('Profile');
    const [userRole, setUserRole] = useState('');
    const [activeTab, setActiveTab] = useState('TIMELINE');

    const breadcrumbs = [
        {"link": "/", "name": "Profile", "active": true}
    ];

    let fetchUser = React.useCallback(async () => {
        if (!currentUser || !currentUser.id) {
            setLoading(false);
            return;
        }
        
        apiUsers.getSingle(currentUser.id).then(res => {
            setRowData(res.user);
            setAllRoles(res.roles);
            setTitle("Profile");
            setLoading(false);
            if (res.user['roles'] && res.user['roles'].length > 0) {
                setUserRole(capitalizeFirst(res.user['roles'][0].name));
            }
        }).catch(err => {
            console.error('Error fetching user:', err);
            setLoading(false);
        });
    }, [currentUser]);

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    useEffect(() => {
        if (!currentUser || !currentUser.id) {
            navigate('/login');
            return;
        }
        setLoading(true);
        fetchUser();
    }, [currentUser, navigate, fetchUser]);

    useEffect(() => {
        if (Object.keys(rowData).length > 0 && rowData['roles'] && rowData['roles'].length > 0) {
            setUserRole(capitalizeFirst(rowData['roles'][0].name));
        }
    }, [rowData]);

    if (!currentUser || !currentUser.id) {
        return null;
    }

    return (
        <Main title={title} breadcrumbs={breadcrumbs} loading={loading}>
            <div className="row">
                <div className="col-md-3">
                    <div className="card card-primary card-outline">
                        <div className="card-body box-profile">
                            <h3 className="profile-username text-center">{rowData['name'] || currentUser.name}</h3>
                            <div className="text-muted text-center">Type (Role): {userRole}</div>
                            <ul className="list-group list-group-unbordered mb-3">
                                <li className="list-group-item">
                                    <b>SFA Applications</b> <a className="float-right">{rowData['sfas']?.length || 0}</a>
                                </li>
                                <li className="list-group-item">
                                    <b>EMPOWER Applications</b> <a className="float-right">{rowData['empowers']?.length || 0}</a>
                                </li>
                                <li className="list-group-item">
                                    <b>Joined</b> <a className="float-right">{formatLocalDate(rowData['created_at'])}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="col-md-9">
                    <div className="card">
                        <div className="card-header p-2">
                            <ul className="nav nav-pills">
                                <li className="nav-item mr-1">
                                    <Button
                                        type="button"
                                        className={`nav-link ${
                                            activeTab === 'TIMELINE' ? 'active' : ''
                                        }`}
                                        onClick={() => toggle('TIMELINE')}
                                    >
                                        Timeline
                                    </Button>
                                </li>
                                <li className="nav-item mr-1">
                                    <Button
                                        type="button"
                                        className={`nav-link ${
                                            activeTab === 'SETTINGS' ? 'active' : ''
                                        }`}
                                        onClick={() => toggle('SETTINGS')}
                                    >
                                        Settings
                                    </Button>
                                </li>
                            </ul>
                        </div>
                        <div className="card-body">
                            <div className="tab-content">
                                <TimelineTab isActive={activeTab === 'TIMELINE'} audits={rowData['audit'] || []} user_name={rowData['name'] || currentUser.name} />
                                <SettingsTab isActive={activeTab === 'SETTINGS'} user={rowData} allRoles={allRoles} setReload={e => {
                                    fetchUser();
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Main>
    );
}

export default Profile;

